<template>
  <report-discription-template class="discription-container">
    <header-title
      slot="heading"
      :title="$t('aiPredictionReport.reportDetail')"
    />

    <disease-name-button2
      :diseaseCode="filteredDiseaseCodes"
      :diseaseCodeIndex="diseaseCodeIndex"
      slot="top-index"
      @setDiseaseCodeIndex="setDiseaseCodeIndex"
    />
    <!-- 病気ごとのリスクここから -->
    <section1 class="section1" slot="top-content">
      <section1-top slot="section1-top">
        <template slot="icon-graph">
          <doughnut-chart-disease-risk
            :riskRate="diseaseRiskIntervals"
            :riskIndex="riskIndex"
          />
        </template>
        <value-with-unit
          slot="risk"
          :value="diseaseRiskRate | fixedPersentage"
          unit="%"
        />
        <display-value
          :value="diseaseName"
          slot="title"
          class="disease-name-title"
        />

        <display-text
          :text="
            $t('aiPredictionReport.differenceFromAvg', { age: age, sex: sex })
          "
          slot="text1"
        />
        <value-with-unit
          :value="culcDifference | round"
          symbole
          unit="%"
          slot="value1"
        />

        <display-text
          :text="$t('aiPredictionReport.percentileRank')"
          slot="text2"
        />
        <value-with-unit
          :value="rankForSameGroup"
          :unit="$t('yourLifestyle.th')"
          slot="value2"
        />
      </section1-top>

      <!-- テキスト1 -->
      <display-text
        slot="section1-middle"
        :text="
          $t('aiPredictionReport.yourRiskForDiseaseIsNum', {
            name: name,
            disease: diseaseName,
            num: roundedDiseaseRiskRate,
          })
        "
      />

      <!-- テキスト2 -->
      <text-bottom
        :age="age"
        :sex="sex"
        :difference="culcDifference"
        :riskIndex="riskIndex"
        slot="section1-bottom"
      />
    </section1>
    <!--病気ごとのリスクここまで -->

    <!-- 病気のリスク分析 -->
    <section2 class="section2" slot="content1">
      <heading
        slot="heading"
        :title="$t('aiPredictionReport.mainRiskIncreasingFactors')"
      />
      <section2-list-item-label
        slot="section2-top-label"
        :riskIndex="riskIndex"
      />
      <section2-list-item
        slot="section2-top"
        v-for="(diseaseRiskFactor, index) in diseaseRiskFactors"
        :key="index"
        :factorCode="diseaseRiskFactor"
        :diseaseCurrentValue="diseaseRiskCurrentValues[diseaseRiskFactor]"
        :convertValue="
          diseaseRiskDangerValues.filter(
            (e) => e.factor === diseaseRiskFactor
          )[0].convert_value | round
        "
        :riskIncreaseAndDecrease="
          (diseaseRiskDangerValues.filter(
            (e) => e.factor === diseaseRiskFactor
          )[0].change_risk_rate -
            diseaseRiskRate)
            | round2
        "
      />

      <section2-bottom slot="section2-bottom" />
    </section2>

    <!-- 正常群との比較分析 -->
    <section4 class="section4" slot="content2">
      <heading
        :title="$t('aiPredictionReport.comparisonWithNormalGroup')"
        slot="heading"
      />
      <!-- レーダーチャート -->
      <!--TODO テキストの書き換え -->
      <display-text
        :text="
          $t('aiPredictionReport.theFollowingAreTheResultsOfAComparisonWith')
        "
        slot="chart-text"
      />
      <radar-chart
        slot="radar-chart"
        :groupAnalysis="groupAnalysis"
        :name="name"
        class="rader-chart"
      />

      <!-- 初期症状 -->
      <display-text
        :text="
          $t('aiPredictionReport.theFollowingAreEarlySymptomsOf%@', {
            disease: diseaseName,
          })
        "
        slot="text-bottom1"
      />
      <!-- 初期症状 -->
      <display-text
        :text="$t(`aiPredictionReport.early_symptom.${diseaseCodeIndex}`)"
        slot="text-bottom2"
      />
    </section4>

    <!-- 予測される危険度 -->
    <section3 slot="content3">
      <heading
        :title="
          $t('aiPredictionReport.changeInEstimatedRiskIfAllMajorFactors', {
            factorNum: this.factorNum,
          })
        "
        v-if="riskRateTotal > 0"
        slot="heading"
      />
      <heading
        :title="
          $t('aiPredictionReport.changeInEstimatedRiskIfImprovements', {
            factorNum: this.factorNum,
          })
        "
        v-else
        slot="heading"
      />
      <div class="risk-rate-total" slot="persent">
        <div v-if="riskRateTotal > 0" class="risk-rate-total__plus">+</div>
        <value-with-unit
          :value="riskRateTotal | round"
          unit="%"
          :class="[
            riskRateTotal > 0
              ? 'risk-rate-total__positive'
              : 'risk-rate-total__normal',
          ]"
        />
      </div>

      <bar-chart-risk-rate
        :riskRate="diseaseRiskIntervals"
        :currentDiseaseRisk="diseaseRiskRate | fixedPersentage"
        :expectedDiseaseRisk="riskRateTotal | fixedPersentage"
        :riskIndex="riskIndex"
        slot="bar-chart"
      />
    </section3>
  </report-discription-template>
</template>

<script>
import VueTypes from "vue-types";

// organisms
import Section1 from "../components/organisms/ReportDiscription/Section1";
import Section2 from "../components/organisms/ReportDiscription/Section2";
import Section3 from "../components/organisms/ReportDiscription/Section3";
import Section4 from "../components/organisms/ReportDiscription/Section4";
import ReportDiscriptionTemplate from "../components/organisms/ReportDiscription/ReportDiscriptionTemplate";

//molecules
import Section1Top from "../components/molecules/ReportDiscription/Section1Top";
import Section2ListItem from "../components/molecules/ReportDiscription/Section2ListItem";
import Section2Bottom from "../components/molecules/ReportDiscription/Section2Bottom";
import ValueWithUnit from "../components/molecules/AIDiseasePredictionReport/ValueWithUnit";
import DiseaseNameButton from "../components/molecules/ReportDiscription/DiseaseNameButton";
import Section2ListItemLabel from "../components/molecules/ReportDiscription/Section2ListItemLabel";
import DiseaseNameButton2 from "../components/molecules/ReportDiscription/DiseaseNameButton2";

//atoms
import TextBottom from "../components/atoms/ReportDiscription/TextBottom";
import Heading from "../components/atoms/AIDiseasePredictionReport/Heading";
import DisplayText from "../components/atoms/displayValue/DisplayText";
import DisplayValue from "../components/atoms/displayValue/DisplayValue";

import HeaderTitle from "../design/HeaderTitleSlot";

// chart
import RadarChart from "../plugin/chart/RadarChartComparisonWithNormalGroup";
import BarChartRiskRate from "../plugin/chart/BarChartRiskRate";
import DoughnutChartDiseaseRisk from "../plugin/chart/DoughnutChartDiseaseRisk";

export default {
  components: {
    // organisms
    Section1,
    Section2,
    Section3,
    Section4,
    ReportDiscriptionTemplate,

    // molecules
    Section1Top,
    Section2ListItem,
    Section2Bottom,
    DiseaseNameButton,
    ValueWithUnit,
    Section2ListItemLabel,
    DiseaseNameButton2,

    // atoms
    TextBottom,
    Heading,
    DisplayText,
    DisplayValue,

    HeaderTitle,
    // chart
    RadarChart,
    BarChartRiskRate,
    DoughnutChartDiseaseRisk,
  },

  data() {
    return {
      // ルートから値(配列操作用の数字)を取得する
      diseaseCodeIndex: this.index,
      filteredDiseaseCodes: [],
    };
  },
  props: {
    index: VueTypes.string.isRequired,
  },
  created: function() {
    const model = this.$store.getters["selvy/getModel"];
    this.filteredDiseaseCodes = Object.keys(model).filter((k) => !model[k]);
  },
  methods: {
    clickLeft() {
      if (this.diseaseCodeIndex === 0) {
        this.diseaseCodeIndex = this.filteredDiseaseCodes.length - 1;
      } else {
        this.diseaseCodeIndex = this.diseaseCodeIndex - 1;
      }
    },
    clickRight() {
      if (this.diseaseCodeIndex === this.filteredDiseaseCodes.length - 1) {
        this.diseaseCodeIndex = 0;
      } else {
        this.diseaseCodeIndex = this.diseaseCodeIndex + 1;
      }
    },
    setDiseaseCodeIndex(val) {
      this.diseaseCodeIndex = val;
    },
  },

  computed: {
    name() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return "";
      }
      return this.$store.getters["selvy/getName"];
    },
    sex() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return 0;
      }
      let sexcode = this.$store.getters["selvy/genderCode"];
      if (sexcode === 1) {
        return this.$i18n.t("yourInformation.men");
      } else {
        return this.$i18n.t("yourInformation.women");
      }
    },
    age() {
      const res = this.$store.state.selvy.status;
      if (!res) {
        return 0;
      }
      let age = this.$store.getters["selvy/getRealAge"];
      return Math.floor(age / 10) * 10;
    },
    diseaseName() {
      return this.$store.state.labels.diseaseNames[this.diseaseCodeIndex];
    },
    diseaseRisk() {
      let diseaseRisks = this.$store.getters["selvy/getDiseaseRisks"];
      return diseaseRisks.find((e) => e.disease === this.diseaseCodeIndex);
    },
    rankForSameGroup() {
      return this.diseaseRisk.rank_for_same_group;
    },
    riskIndex() {
      return this.diseaseRisk.risk_index;
    },
    diseaseRiskRate() {
      return this.diseaseRisk.risk_rate;
    },
    diseaseRiskIntervals() {
      return this.diseaseRisk.risk_intervals;
    },
    diseaseRiskRateSameGroup() {
      return this.diseaseRisk.risk_rate_same_group;
    },
    culcDifference() {
      return Math.floor(this.diseaseRiskRate - this.diseaseRiskRateSameGroup);
    },
    roundedDiseaseRiskRate() {
      const rdr = Math.floor((this.diseaseRiskRate * 10) / 10);
      if (rdr === 0) {
        return 1;
      } else if (rdr === 100) {
        return 99;
      } else {
        return rdr;
      }
    },
    riskRateTotal() {
      return Math.floor(
        this.riskFactors.risk_rate_total - this.diseaseRiskRate
      );
    },
    riskFactors() {
      let riskFactors = this.$store.getters["selvy/getRiskFactors"];
      return riskFactors.find((e) => e.disease === this.diseaseCodeIndex);
    },
    // 病気のリスク分析の項目名を取得するためのコードを配列で取得する
    diseaseRiskFactors() {
      return this.riskFactors.risk_factors.map((e) => e.factor);
    },
    factorNum() {
      return this.diseaseRiskFactors.length;
    },
    // 項目名と入力値を格納したオブジェクト
    diseaseRiskCurrentValues() {
      const arr = this.$store.getters["selvy/getParameter"].features[0];
      const arr2 = Object.keys(arr).map((k) => arr[k]);
      const obj = {
        ...arr2[0],
        ...arr2[1],
        ...arr2[2],
        ...arr2[3],
        ...arr2[4],
        ...arr2[5],
        ...arr2[6],
        ...arr2[7],
        ...arr2[8],
        ...arr2[9],
      };
      return obj;
    },
    diseaseRiskDangerValues() {
      return this.riskFactors.risk_factors;
    },

    groupAnalysis() {
      let groupAnalysis = this.$store.getters["selvy/getGroupAnarysis"];
      return groupAnalysis.find((e) => e.disease === this.diseaseCodeIndex)
        .factors;
    },
  },

  filters: {
    //TODO 不要(group_ageから取得するように変更する)
    round(value) {
      return Math.round(value * 10) / 10;
    },
    round2(value) {
      return Math.round(value * 100) / 100;
    },
    round3(value) {
      return Math.round(value * 1000) / 1000;
    },
    fixedPersentage: function(value) {
      let val = Math.floor(value);
      if (val === 0) {
        return 1;
      } else if (val === 100) {
        return 99;
      } else {
        return val;
      }
    },
  },
};
</script>

<style scoped>
.disease-name-title {
  font-size: 2em;
  font-weight: bold;
}
.risk-rate-total {
  line-height: 3rem;
  display: flex;
  justify-content: center;
  color: red;
}
.risk-rate-total >>> .value-wrapper > .value {
  font-size: 3rem;
}
.risk-rate-total >>> .value-wrapper > .unit {
  font-size: 2rem;
}
.risk-rate-total__plus {
  font-size: 2rem;
}
.risk-rate-total__positive {
  color: red;
}
.risk-rate-total__normal {
  color: #00a2de;
}
</style>
